import dayjs from 'dayjs';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import formatDate from 'ember-intl/helpers/format-date';
import formatTime from 'ember-intl/helpers/format-time';
import { eq, not, or } from 'ember-truth-helpers';
import WrLinkTo from 'ember-wiser/components/link-to';
import ArchiveJournalEventButton from 'parog-web/components/archive-journal-event-button';
import type DeseaseHistoryJournalEvent from 'parog-web/models/desease-history-journal-event';
interface Signature {
  Args: {
    journalEvent: DeseaseHistoryJournalEvent;
  };
}

/**
 * Compare Date a with Date b
 * return true if a is before b with day granularity
 */
function compareDates(a: Date, b: Date) {
  return dayjs(a).isBefore(dayjs(b), 'day');
}

const CardEventComponent: TemplateOnlyComponent<Signature> = <template>
  <div
    class='bg-grey-light text-grey my-4 flex p-4'
    data-test-card-event='{{@journalEvent.id}}'
  >
    <div class='w-full'>
      {{#let
        (compareDates @journalEvent.occurredAt @journalEvent.createdAt)
        as |eventDeclaredInThePast|
      }}
        <div data-test-occurredAt>
          Le
          {{formatDate @journalEvent.occurredAt format='DD/MM/YYYY'}}
          {{#unless eventDeclaredInThePast}}
            à
            {{formatTime @journalEvent.occurredAt format='hhmm'}}
          {{/unless}}
        </div>
        <div
          class='my-2 whitespace-pre-line text-justify'
          data-test-card-content
        >{{@journalEvent.content}}</div>
        <div class='flex place-content-between'>
          <div data-test-updatedAt>
            {{#let
              (not
                (eq
                  (concat
                    (formatDate @journalEvent.createdAt format='DD/MM/YYYY')
                    (formatTime @journalEvent.createdAt format='hhmm')
                  )
                  (concat
                    (formatDate @journalEvent.updatedAt format='DD/MM/YYYY')
                    (formatTime @journalEvent.updatedAt format='hhmm')
                  )
                )
              )
              as |eventUpdated|
            }}
              {{#if (or eventDeclaredInThePast eventUpdated)}}
                Modifié le
                {{formatDate @journalEvent.updatedAt format='DD/MM/YYYY'}}
                à
                {{formatTime @journalEvent.updatedAt format='hhmm'}}
              {{/if}}
            {{/let}}
          </div>
          <div data-test-creator-name>{{@journalEvent.creator.name}}</div>
        </div>
      {{/let}}
    </div>
    <div class='pl-4'>
      <div>
        <WrLinkTo
          @route='medics-web.protected.patients.patient.dashboard.medical-history.desease-event.edition'
          @model={{@journalEvent}}
          @variant='outlined-mini'
          @icon='Pen'
          data-test-edit-card-event
        />
      </div>
      <div>
        <ArchiveJournalEventButton
          @shouldUseWiser={{true}}
          @journalEvent={{@journalEvent}}
          data-test-archive-card-event
        />
      </div>
    </div>
  </div>
</template>;

export default CardEventComponent;
